const worker = state => state.worker;
const worker_list = state => state.worker_list;
const failed_jobs = state => state.failed_jobs;
const pending_jobs = state => state.pending_jobs;
const sync_jobs = state => state.sync_jobs;
const meta = state => state.meta;

export {
    worker,
    worker_list,
    failed_jobs,
    pending_jobs,
    sync_jobs,
    meta
}
